var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPanelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 104,
    viewBox: "0 0 149 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1662_4349)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.7489,
    cy: 61.9318,
    r: 41.0279,
    stroke: "#959595",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.0424,
    cy: 49.5918,
    rx: 4.02948,
    ry: 4.83398,
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.1014,
    cy: 49.5918,
    rx: 4.02948,
    ry: 4.83398,
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.157 77.4141L88.3408 86.8086",
    stroke: "#959595",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.472 7.24328L130.08 34.5015L135.881 8.16487C137.252 1.41711 129.496 0.747841 129.472 7.24328Z",
    fill: "#959595",
    stroke: "#959595",
    strokeWidth: 0.692226,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.36,
    cy: 39.0117,
    r: 2.27969,
    transform: "rotate(-3.21127 129.36 39.0117)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9331 14.2556L17.1826 36.6343L9.77899 15.6561C7.97606 10.2697 14.2585 8.93994 14.9331 14.2556Z",
    fill: "#959595",
    stroke: "#959595",
    strokeWidth: 0.571032,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.57069,
    cy: 1.57069,
    r: 1.57069,
    transform: "matrix(-0.997793 0.0664051 0.0664051 0.997793 19.5122 37.8398)",
    fill: "#959595"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1662_4349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPanelIcon);
export default __webpack_public_path__ + "static/media/noPanelIcon.23d4b7cf1d4d42ee770383c91fb69491.svg";
export { ForwardRef as ReactComponent };